import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 minute
      refetchOnWindowFocus: true,
      // Always fetch latest data when a page remounts (e.g. after navigation).
      refetchOnMount: 'always',
    },
  },
});
